import { render, staticRenderFns } from "./ResultsList.html?vue&type=template&id=968e963e&"
import script from "./ResultsList.vue?vue&type=script&lang=ts&"
export * from "./ResultsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports